import {DRAG_GHOST_EXCLUDE_ATTRIBUTE} from '@Libraries/canvas-item-drag.library';

/** Spread onto selection chrome so drag previews leave it out (see the drag library's ghost builders). */
export const DRAG_GHOST_EXCLUDE_PROPS = {[DRAG_GHOST_EXCLUDE_ATTRIBUTE]: ''};
